/* import __COLOCATED_TEMPLATE__ from './option.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';
import { type ChildAction, type ParentAction } from 'embercom/objects/inbox/command-k/action';

interface Signature {
  Args: {
    actionItem: ChildAction;
    currentAction: ParentAction;
  };
}

const Option = templateOnlyComponent<Signature>();
export default Option;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::UseMacro::Option': typeof Option;
    'inbox2/command-k/use-macro/option': typeof Option;
  }
}
